/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */

/* These eslint disablers were need in order to get pass the linter for commiting */
enum HelperStatus {
  Error,
  Valid,
  Neutral,
  Warn,
  Trust,
  Inactive,
  Recruit,
}

export default HelperStatus;
